import { UnitYearlyCosts } from 'features/siteView/utils/getPlanCostsByUnit'
import { sum } from 'lodash'
import { arange } from 'utils/arange'

/**
 * Sums the costs for each year in the range [startYear, endYear] (inclusive).
 */
export function sumCostsInYearRange(
  yearlyCosts: UnitYearlyCosts,
  startYear: number,
  endYear: number
): number {
  const yearsToSum = arange(startYear, endYear + 1)

  return yearsToSum.reduce<number>((totalCostInSpan, year) => {
    const planCostsThisYear = Object.values(yearlyCosts).map(
      (unitCosts) => unitCosts?.[year]?.planBaseCost ?? 0
    )

    return sum([totalCostInSpan, ...planCostsThisYear])
  }, 0)
}
